import { getKey } from '../getKey';
import { getStorage } from '../getStorage';
// GetItem and GetGlobalItem will return:
// 1. An object of type T if key is present
// 2. undefined in web storage is unavailable or corrupted
// 3. null if a null or undefined object was previously passed to setItem
function getStorageItem(key, storageType, userId) {
    var storage = getStorage(storageType);
    if (!storage) {
        return undefined;
    }
    var itemKey = getKey(key, userId);
    var item = storage.getItem(itemKey);
    return typeof item === 'string' ? JSON.parse(item) : undefined;
}
export function getGlobalItem(key, storageType) {
    if (storageType === void 0) { storageType = "localStorage" /* StorageType.LocalStorage */; }
    return getStorageItem(key, storageType);
}
export function getUserItem(userId, key, storageType) {
    if (storageType === void 0) { storageType = "localStorage" /* StorageType.LocalStorage */; }
    return getStorageItem(key, storageType, userId);
}
//# sourceMappingURL=getItem.js.map